// extracted by extract-css-chunks-webpack-plugin
module.exports = {"Tooltip":"Tooltip__Tooltip--1Oa8X"};